import { MenuItem, MenuList } from '@material-tailwind/react';
import React from 'react'

const menuItems = [
    {name: 'Blog List', link: '/blog-list'},
    {name: 'Blog Single', link: '/blog-single'}
];

function BlogsDropDown({ mobile = false }) {
    return (
        <MenuList className={`${mobile ? 'ml-2 md:ml-4 w-full' : 'min-w-[180px]'} z-[100] p-2 dark:bg-dark-1 rounded-lg shadow-lg`}>
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    className='hover:bg-blue-50 hover:text-blue-600 w-full px-4 py-3 text-sm text-dark-1
                    dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400 transition-colors
                    rounded-md flex items-center'
                >
                    <a href={item.link} className="w-full">{item.name}</a>
                </MenuItem>
            ))}
        </MenuList>
    )
}

export default BlogsDropDown